var render = function render(_c, _vm) {
  return _c("div", { class: _vm.$style.header }, [
    _c("div", { class: _vm.$style.icon }, [_vm._t("icon")], 2),
    _c("div", { class: _vm.$style.headerTitle }, [
      _c("h2", { class: _vm.$style.headerSub }, [_vm._t("subTitle")], 2),
      _c("h1", { class: _vm.$style.headerMain }, [_vm._t("title")], 2),
    ]),
    _c("div", { class: _vm.$style.headerClose }, [
      _c(
        "button",
        {
          staticClass: "vModalDefaultCloseButton",
          on: {
            click: function ($event) {
              return _vm.listeners.cancel()
            },
          },
        },
        [_vm._v("close")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }